<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb" style="padding-top: 20px">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          {{ $t("app.modules.reports.title") }}
        </el-breadcrumb-item>
        <h6 style="margin-bottom: 0px" class="text-right">
          {{ $t("app.welcome") }} {{ this.$store.state.user.nombre }}
        </h6>
      </el-breadcrumb>

      <td class="col-11"></td>
      <td class="col-2">
        <h7 style="margin-bottom: 0px" class="text-right"
          >{{ this.$store.state.user.cliente.razonSocial }}
        </h7>
      </td>
    </div>
    <el-divider></el-divider>

    <div
      class="
        col-12
        d-flex
        justify-content-center justify-content-sm-between
        flex-wrap
      "
    >
      <h4 class="card-title text-purple">
        {{ $t("app.modules.reports.back_order") }}
      </h4>

      <div class="text-right">
        <n-button type="info" round @click.native="exportExcel">
          {{ $t("app.buttons.excel") }}
        </n-button>
      </div>

      <!--
      <xlsx-workbook v-if="excelData">
        <xlsx-sheet
          v-for="sheet in excelData"
          :key="sheet.name"
          :collection="sheet.data"
          :sheet-name="sheet.name"
        />
        <xlsx-download :filename="excelName" disable-wrapper-click>
          <template #default="{ download }">
            <n-button
              type="primary"
              @click.native="download"
              class="pull-left"
              style="
                float: right;
                margin-right: 20px;
                border-radius: 0px !important;
              "
              round
            >
              {{ $t("app.modules.reports.headers.download") }}
              {{ $t("app.modules.reports.back_order") }}
              <i
                slot="label"
                class="now-ui-icons arrows-1_cloud-download-93"
              ></i>
            </n-button>
          </template>
        </xlsx-download>
      </xlsx-workbook>
      -->
    </div>

    <el-table stripe style="width: 100%" :data="account">
      <el-table-column
        prop="numeroPedidoSAP"
        :label="this.$t('app.modules.reports.headers.purchase_order')"
        sortable
        min-width="250"
        
      >
      </el-table-column>
      <el-table-column
        prop="nombreProducto"
        :label="this.$t('app.modules.add_by_part_number.part_number')"
        sortable
        min-width="200"
        
      >
      </el-table-column>
      <el-table-column
        prop="descripcionProducto"
        :label="this.$t('app.modules.reports.headers.description')"
        sortable
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        prop="cantidad"
        :label="this.$t('app.modules.reports.headers.order_quantity')"
        min-width="200"
        align="right"
      >
      </el-table-column>
      <el-table-column
        prop="cantidadPendiente"
        :label="this.$t('app.modules.reports.headers.back_order_quantity')"
        min-width="250"
        align="right"
      >
      </el-table-column>
      <el-table-column
        prop="precioUnitario"
        :label="this.$t('app.modules.reports.headers.unit_price')"
        min-width="150"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.precioUnitario | currencyFormat  }}
        </template>
      </el-table-column>
      <el-table-column
        prop="precioTotal"
        :label="this.$t('app.modules.reports.headers.total_price')"
        min-width="150"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.precioTotal | currencyFormat }}
        </template>
      </el-table-column>
      <el-table-column
        prop="fechaVencimiento"
        :label="this.$t('app.modules.reports.headers.due_date')"
        sortable
        min-width="200"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
/*
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from 'vue-xlsx'

export default {
  name: "BackOrderReport",
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data () {
    return {
      items: [
        {
          "purchase_order": "41167-6032",
          "product": "30142-567",
          "description": "Nullam molestie nibh in lectus.",
          "order_quantity": 61,
          "back_order_quantity": 27,
          "unit_price": "$6.49",
          "total_price": "$55.57",
          "due_date": "2021-03-03"
        },
        {
          "purchase_order": "35356-694",
          "product": "37808-946",
          "description": "Morbi ut odio.",
          "order_quantity": 99,
          "back_order_quantity": 80,
          "unit_price": "$4.55",
          "total_price": "$55.80",
          "due_date": "2021-08-05"
        },
        {
          "purchase_order": "0268-6129",
          "product": "20276-432",
          "description": "Aliquam non mauris.",
          "order_quantity": 48,
          "back_order_quantity": 34,
          "unit_price": "$6.33",
          "total_price": "$11.06",
          "due_date": "2021-03-14"
        },
        {
          "purchase_order": "21695-805",
          "product": "13537-496",
          "description": "Donec quis orci eget orci vehicula condimentum.",
          "order_quantity": 61,
          "back_order_quantity": 4,
          "unit_price": "$5.34",
          "total_price": "$31.69",
          "due_date": "2021-06-16"
        },
        {
          "purchase_order": "60505-3111",
          "product": "49738-619",
          "description": "Nulla tempus.",
          "order_quantity": 36,
          "back_order_quantity": 87,
          "unit_price": "$2.59",
          "total_price": "$33.04",
          "due_date": "2021-07-18"
        },
        {
          "purchase_order": "41250-467",
          "product": "0378-4884",
          "description": "Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo.",
          "order_quantity": 70,
          "back_order_quantity": 42,
          "unit_price": "$3.67",
          "total_price": "$16.99",
          "due_date": "2021-09-09"
        },
        {
          "purchase_order": "0185-0505",
          "product": "52072-003",
          "description": "Duis bibendum.",
          "order_quantity": 31,
          "back_order_quantity": 68,
          "unit_price": "$2.19",
          "total_price": "$73.20",
          "due_date": "2021-02-13"
        },
        {
          "purchase_order": "54575-296",
          "product": "50436-7076",
          "description": "Vestibulum quam sapien, varius ut, blandit non, interdum in, ante.",
          "order_quantity": 33,
          "back_order_quantity": 45,
          "unit_price": "$6.00",
          "total_price": "$87.78",
          "due_date": "2021-07-28"
        },
        {
          "purchase_order": "51672-4155",
          "product": "0703-4764",
          "description": "In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem.",
          "order_quantity": 32,
          "back_order_quantity": 15,
          "unit_price": "$7.11",
          "total_price": "$52.02",
          "due_date": "2021-05-18"
        },
        {
          "purchase_order": "49349-682",
          "product": "36800-092",
          "description": "Nulla mollis molestie lorem.",
          "order_quantity": 30,
          "back_order_quantity": 26,
          "unit_price": "$0.14",
          "total_price": "$38.35",
          "due_date": "2020-11-23"
        }
      ],
      excel: []
    }
  },
  computed: {
    excelName () {
      return this.$t("app.modules.reports.title") + ' ' + this.$t("app.modules.reports.back_order") + '.xlsx'
    },
    excelData () {
      return [{
        name: this.excelName,
        data: this.items.map(item => {
          let el = new Map([
            [this.$t('app.modules.reports.headers.purchase_order'), item.purchase_order],
            [this.$t('app.modules.reports.headers.product'), item.product],
            [this.$t('app.modules.reports.headers.description'), item.description],
            [this.$t('app.modules.reports.headers.order_quantity'), item.order_quantity],
            [this.$t('app.modules.reports.headers.back_order_quantity'), item.back_order_quantity],
            [this.$t('app.modules.reports.headers.unit_price'), item.unit_price],
            [this.$t('app.modules.reports.headers.total_price'), item.total_price],
            [this.$t('app.modules.reports.headers.due_date'), item.due_date]
          ])

          return Object.fromEntries(el)
        })
      }]
    }
  }
};
*/

import VueHtml2pdf from "vue-html2pdf";
import moment from "moment";
import { number_format, getResponse } from "@/util/utilities";
import { Direccion } from "@/models/pedidos/Direccion";
import XLSX from "xlsx";
export default {
  components: {
    VueHtml2pdf,
  },
  data() {
    return {
      tableData: [],
      currDate: new Date(),
      item: {},
      account: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      direccion: new Direccion(),
      headers: [
        this.$t("app.modules.reports.headers.purchase_order"),
        this.$t("app.modules.add_by_part_number.part_number"),
        this.$t("app.modules.reports.headers.description"),
        this.$t("app.modules.reports.headers.order_quantity"),
        this.$t("app.modules.reports.headers.back_order_quantity"),
        this.$t("app.modules.reports.headers.unit_price"),
        this.$t("app.modules.reports.headers.total_price"),
        this.$t("app.modules.reports.headers.due_date"),
      ],
    };
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      // return this.account.reduce((acc, item) => acc + item.monto, 0);
      return this.account.length;
    },
  },
  async mounted() {
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getAccount();
    await this.getDireccionFiscal();

    this.$swal.close();
  },
  filters: {
    currencyFormat(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(",", ".");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return null;
    },
  },
  methods: {
    exportExcel() {
      let data = [this.headers].concat(this.getData());

      console.log("Objeto data" + JSON.stringify(data));
      /* convert state to workbook */
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
      /* generate file and send to client */
      XLSX.writeFile(wb, this.$t("app.modules.reports.filename"));
    },
    getData() {
      let data = this.tableData;
      let _data = [];
      data.forEach((val) => {
        let response = [];
        response.push(val.numeroPedidoSAP);
        response.push(val.nombreProducto);
        response.push(val.descripcionProducto);
        response.push(val.cantidad);
        response.push(val.cantidadPendiente);
        response.push(val.precioUnitario);
        response.push(val.precioTotal);
        response.push(val.fechaVencimiento);
        _data.push(response);
      });

      return _data;
    },
    number_format,
    async getAccount() {
      var payload = {
        id: this.$store.state.user.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("BackOrder/getBackOrder"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.account = response.body.backOrders;
              this.tableData = response.body.backOrders;

              console.log(
                "Valor de account --> " + JSON.stringify(this.account)
              );
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async savePDF() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });

      var payload = {
        id: this.item.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: 1,
        direccionFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_address"
        ),
        idClienteSAP: this.$t(
          "app.modules.account_statements.headers.client_id"
        ),
        facturaFiscal: this.$t(
          "app.modules.account_statements.headers.fiscal_bill"
        ),
        facturaComercial: this.$t(
          "app.modules.account_statements.headers.commercial_bill"
        ),
        fechaFaturacion: this.$t(
          "app.modules.account_statements.headers.bill_date"
        ),
        moneda: this.$t("app.modules.account_statements.headers.money"),
        monto: this.$t("app.modules.account_statements.headers.amount"),
        terminosPago: this.$t(
          "app.modules.account_statements.headers.payment_terms"
        ),
        fechaVencimiento: this.$t(
          "app.modules.account_statements.headers.expire_date"
        ),
      };

      await this.$http
        .post(route("EstadoCuenta/getEstadosCuentaClientePDF"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.report_url = response.body.ruta;
              console.log(this.report_url);
              window.open(this.report_url, "_blank");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});

      this.$swal.close();
    },
    getPDF() {
      // this.$router.push({ path: 'estado_cuenta_cliente_pdf', params: this.item })
      this.$refs.html2Pdf.generatePdf();
    },
    parseDatetime(dt) {
      console.log(dt);
      var year = dt.getFullYear();
      var month = (dt.getMonth() + 1).toString().padStart(2, "0");
      var day = dt.getDate().toString().padStart(2, "0");
      return year + "-" + month + "-" + day;
    },
    parseDateMoment(dt) {
      return moment(dt).format("YYYY/MM/DD");
    },
    getFechaVencimiento(fechaBase, terminos) {
      return moment(fechaBase).add(terminos, "days").format("YYYY/MM/DD");
    },
    async getDireccionFiscal() {
      var payload = {
        idClienteSAP: this.$store.state.user.idClienteSAP.toString(),
      };

      await this.$http
        .post(route("EstadoCuenta/getDireccionFiscalByClienteSAP"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.direccion = response.body.direcciones[0];
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    subtotal(movs) {
      return movs.reduce((acc, item) => acc + item, 0);
    },
    grantotal() {
      return this.tableData.reduce(
        (acc, item) => acc + this.subtotal(item.movimientos),
        0
      );
    },
    startPagination() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false,
      });
    },
    hasDownloaded($event) {
      this.$swal.close();
    },
  },
};
</script>

<style scoped>
</style>
